import Link from "next/link";
import { GAMES } from "@/app/(public)/(products)/games/gamesConfig";

export function OtherGames({ currentGameId }: { currentGameId: string }) {
  const otherGames = GAMES.filter((game) => game.id !== currentGameId);

  if (otherGames.length === 0) return null;

  return (
    <div className="mt-8 pt-8 border-t border-gray-200">
      <h3 className="text-center text-lg font-semibold mb-4 text-gray-700">Try Other Games</h3>
      <div className="flex flex-wrap gap-3 justify-center">
        {otherGames.map((game) => (
          <Link key={game.id} href={game.href}>
            <button
              className={`${
                game.color === "purple"
                  ? "bg-purple-100 hover:bg-purple-200 text-purple-700"
                  : game.color === "green"
                    ? "bg-green-100 hover:bg-green-200 text-green-700"
                    : "bg-indigo-100 hover:bg-indigo-200 text-indigo-700"
              } px-4 py-2 rounded-lg font-medium transition-all transform hover:scale-105 text-sm`}
            >
              Play {game.title} →
            </button>
          </Link>
        ))}
      </div>
    </div>
  );
}
